import React, { memo, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import LoadingButton from '../../forms/LoadingButton';
import ModalHeader from '../partials/modalHeader';
import { postRequest } from '../../../utils/axiosRequests';

const DynamicItemGroupForm = ({
  isGroupModal,
  setIsGroupModal,
  modalTitle,
  prescriptionItemId,
  itemNames,
  elementGroups,
  setElementGroups,
  selectedGroups,
  setSelectedGroups,
  selectedItems,
  setSelectedItems,
}) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError('Group name is required');
      return;
    }
    setIsLoading(true);
    try {
      const data = await postRequest('dynamic-prescription-items/element-groups', {
        prescriptionItemId,
        name: name.trim(),
        itemNames,
      });
      setElementGroups([...elementGroups, data]);
      setSelectedGroups([...selectedGroups, data]);
      const newItems = (data.itemNames || itemNames)
        .filter((n) => !selectedItems.some((i) => i.name === n))
        .map((n) => ({ name: n, date: '', note: '' }));
      setSelectedItems([...selectedItems, ...newItems]);
      setName('');
      setError('');
      setIsGroupModal(false);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={isGroupModal} size="md" className="child-modal">
      <ModalHeader title={`${modalTitle} Group`} action={setIsGroupModal} />
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label className="label-custom">Group Name</Form.Label>
            <Form.Control
              type="text"
              size="sm"
              className={error ? 'v-border' : ''}
              placeholder="Enter group name"
              autoFocus
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError('');
              }}
            />
            <small className="v-error">{error}</small>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={() => setIsGroupModal(false)}>
          Close
        </Button>
        <div className="d-grid gap-2">
          {isLoading ? (
            <LoadingButton btnFull="yes" />
          ) : (
            <Button variant="primary" size="sm" onClick={handleSubmit}>
              Save Changes
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(DynamicItemGroupForm);
